import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { useEffect } from 'react'
import { getStepComponent } from './stepRegistry'
import { Button, Stack } from '@forwardflow/ui-v2'

/**
 * OnboardingSteps Component
 *
 * Main router for onboarding flow. Uses the step registry pattern to render
 * the appropriate component based on the current step.
 *
 * Benefits of this approach:
 * - No large switch statement
 * - Easy to add/remove steps
 * - Centralized step management
 * - Better testability
 */
export const OnboardingSteps = () => {
   const { getCurrentStep, goToStep, onboardingSaveBlocked } = useOnboardingStoreV2()
   const currentStep = getCurrentStep()

   // Scroll to top when step changes for better UX
   useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }, [currentStep])

   // Get the component for the current step from the registry
   const StepComponent = getStepComponent(currentStep)

   if (StepComponent) return <StepComponent />

   return (
      <Stack gap={16}>
         <h2 className="text-xl font-semibold">Your saved setup step is unavailable</h2>
         <p>Your saved answers have not been reset. Reload to check for an update, or go back to the first step to continue.</p>
         <Button onClick={() => window.location.reload()}>Reload</Button>
         <Button disabled={Boolean(onboardingSaveBlocked)} onClick={() => goToStep('fub-connect')}>
            Start from the first step
         </Button>
      </Stack>
   )
}
